module.exports = __webpack_public_path__ + "img/play@2x.ff31bbc4.png";